// extracted by mini-css-extract-plugin
module.exports = {"sectionClientsTable":"PhysiciansShow_sectionClientsTable__1HpZX","tableWrap":"PhysiciansShow_tableWrap__2Ry3A"};